/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { EmptyLayout } from 'core/components/Layouts/EmptyLayout';
import { Result } from 'core/components/ui/Result';

type Props = {
  children?: any;
  onError?: (error: Error, componentStack: string) => void;
};

type ErrorInfo = {
  componentStack: string;
};

type State = {
  error: Error | null;
};

export class ErrorHandler extends React.Component<Props, State> {
  // eslint-disable-next-line react/state-in-constructor
  public state: State = {
    error: null,
  };

  componentDidCatch(error: Error, info: ErrorInfo) {
    const { onError } = this.props;

    /* istanbul ignore else */
    if (typeof onError === 'function') {
      try {
        onError.call(this, error, info?.componentStack);
      } catch {
        // ignore
      }
    }

    this.setState({ error });
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;

    if (error === null) {
      return children;
    }

    const message = error.toString();

    return (
      <EmptyLayout data-test-id="error-handler">
        <Result extra={message} status="500" title="500" />
      </EmptyLayout>
    );
  }
}
